/**
 * スマホ用フルスクリーンメニュー（ハンバーガー開閉）
 */

const OPEN_CLASS = 'is-drawer-open';
const BODY_OPEN_CLASS = 'is-header-drawer-open';
const CLOSE_TRANSITION_MS = 320;

export default class HeaderDrawer {
  constructor() {
    this.toggle = document.querySelector('[data-js-header-drawer-toggle]');
    this.drawer = document.querySelector('[data-js-header-drawer]');
    this._lastFocused = null;
    this._onKeydown = this._onKeydown.bind(this);
    this._closeTimer = null;
  }

  init() {
    if (!this.toggle || !this.drawer) {
      return;
    }

    this.toggle.addEventListener('click', () => {
      if (this.drawer.classList.contains(OPEN_CLASS)) {
        this._close();
      } else {
        this._open();
      }
    });

    this.drawer.addEventListener('click', (e) => {
      const closeEl = e.target.closest('[data-js-header-drawer-close]');
      if (closeEl) {
        this._close();
        return;
      }
      const link = e.target.closest('a[href]');
      if (link && this.drawer.contains(link)) {
        this._close();
      }
    });

    window.addEventListener('resize', () => {
      if (
        window.matchMedia(`(min-width: ${this._breakpointPx}px)`).matches &&
        this.drawer.classList.contains(OPEN_CLASS)
      ) {
        this._close();
      }
    });
  }

  /**
   * scss の `min-screen($breackpoint_md + 1px)` と同期（769px 以上で PC）
   */
  get _breakpointPx() {
    return 769;
  }

  _open() {
    if (this.drawer.classList.contains(OPEN_CLASS)) {
      return;
    }

    window.clearTimeout(this._closeTimer);
    this._lastFocused = document.activeElement;

    this.drawer.hidden = false;

    requestAnimationFrame(() => {
      this.drawer.classList.add(OPEN_CLASS);
      document.body.classList.add(BODY_OPEN_CLASS);
      this.toggle.setAttribute('aria-expanded', 'true');
      this.drawer.setAttribute('aria-hidden', 'false');

      const closer = this.drawer.querySelector('[data-js-header-drawer-close]');
      if (closer && typeof closer.focus === 'function') {
        closer.focus();
      }

      document.addEventListener('keydown', this._onKeydown);
    });
  }

  _close() {
    if (!this.drawer.classList.contains(OPEN_CLASS)) {
      return;
    }

    document.removeEventListener('keydown', this._onKeydown);

    this.drawer.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_OPEN_CLASS);
    this.toggle.setAttribute('aria-expanded', 'false');
    this.drawer.setAttribute('aria-hidden', 'true');

    window.clearTimeout(this._closeTimer);
    this._closeTimer = window.setTimeout(() => {
      if (!this.drawer.classList.contains(OPEN_CLASS)) {
        this.drawer.hidden = true;
      }
    }, CLOSE_TRANSITION_MS);

    if (this._lastFocused && typeof this._lastFocused.focus === 'function') {
      this._lastFocused.focus();
    }
    this._lastFocused = null;
  }

  _onKeydown(e) {
    if (e.key === 'Escape') {
      this._close();
    }
  }
}
